import { useFetchQuickSearchCriteria } from "../criteria/quick-search/useFetchQuickSearchCriteria";
import { criteriaType, customizeQuickSearchType } from "../../common/types/search/search";

interface QuickSearchCriteriaInitializerProps {
	namespace: string;
	criteria: criteriaType;
	customizeQuickSearch?: customizeQuickSearchType;
}

export const QuickSearchCriteriaInitializer = ({
	namespace,
	criteria,
	customizeQuickSearch,
}: QuickSearchCriteriaInitializerProps) => {
	useFetchQuickSearchCriteria(
		namespace,
		criteria.quickSearchFallbackCriteria,
		criteria.shouldFetchQuickSearchCriteria,
		criteria.criteria,
		criteria.quickSearchCriteriaOrder,
		customizeQuickSearch,
	);

	return null;
};
